import { Menu, Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import UserBadge from "../../../../../../../../Users/UserBadge/UserBadge";
import { useAuth } from "../../../../../../../../../AuthContext";
import { USERS_PATH } from "../../../../../../../../../routes";
import { Link } from "@tanstack/react-router";

function ProfileLink() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const role =
    user?.Role === 1 ? t("common.roles.admin") : t("common.roles.teacher");
  return (
    <Menu.Item
      leftSection={
        <UserBadge firstName={user?.FirstName} lastName={user?.LastName} />
      }
      component={Link}
      to={`${USERS_PATH}/${user?.ID}/courses`}
    >
      <Stack gap={0}>
        <Text size="xs" fw={700} c="bluegray.3">
          {user?.FirstName} {user?.LastName}
        </Text>
        <Text size="xs" c="bluegray.4">
          {role}
        </Text>
      </Stack>
    </Menu.Item>
  );
}

export default ProfileLink;
